<template>
  <div>
    <div class="router-header flex flex-wrap items-center mb-3">
      <div
        class="content-area__heading pr-4"
      >
        <!--<h4 class="mb-1">Attributes History</h4>-->
        <!--<div class="mt-2 mb-1">Select one to continue</div>-->
      </div>
    </div>
    <div class="vx-row">
      <div
        v-for="comp in completed"
        :key="comp.id"
        class="vx-col w-full"
      >

          <div class="vx-card overflow-hidden mb-2" @click="toSkillDetails(comp.i)">
            <div class="vx-card__collapsible-content vs-con-loading__container">
              <div>
                <div class="p-6 flex items-center">
                  <span
                    class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mc-icon"
                    style="background: rgba(var(--vs-primary),0.15);"
                  >
                    <img :src="comp.icon" alt="" width="40px" height="40px"  />
                  </span>
                  <div class="truncate">
                    <h5 class="mb-1">{{ comp.comp }}</h5>
                    <!--<span style="color: white;">{{ comp.value }}</span
                    >-->
                  </div>
                </div>
              </div>
            </div>
            <!--<div
              class="vx-card__collapsible-content vs-con-loading__container pt-2 mt-2"
            >
              <div>
                <div class="p-6 flex items-center pt-0">
                  <div class="truncate t-content">
                    <span style="color: white;">{{ comp.wdd }}</span>
                  </div>
                </div>
              </div>
            </div>-->
          </div>

      </div>
    </div>
  </div>
</template>

<script>
// import ccd from "@/assets/data/charactersistic-competency-definition";
import constants from "../../../constants.js";

// Store Module
// import moduleAddSkill from "@/store/add-skill/moduleCompetencyProgress.js";

export default {
  name: "MySkills",
  props: ['completed'],
  data() {
    return {
      allCompetencies: [],
      CCD: this.$t("addNewSkill.data"),
      constants
    };
  },
  created() {},
  methods: {
    toSkillDetails(traineeCompetenciesId) {
      this.$router.push({ name: "skill-details", params: {traineeCompetenciesId} });
    }
  },
  mounted() {}
};
</script>

<style scoped>
.greyscale{
  mix-blend-mode: color-burn;
}
.vx-card {
  cursor: pointer;
}

.vx-card:hover {
  background: #F9F9F9;
}

.competency-img {
  width: 30px;
  height: 30px;
  margin: auto;
}

.selectedCompetency {
  background: #9dcd5b! important;
  color: white! important;
}

.selected-competency .competency-title h4 {
  color: white;
}
/*.con-vs-card {
      margin-bottom: 0.4rem;
      !*-webkit-box-shadow: none;
        box-shadow: none;*!
      min-height: 79px;
    }*/

.con-vs-card >>> .vs-card--content {
  padding: 3px 8px 3px 8px !important;
  margin-bottom: 10px;
}

.truncate {
  white-space: normal !important;
}

.truncate h5 {
  margin-left: 1.5rem;
}

.truncate span {
  display: none;
}

.selectedCompetency >>> span.mc-icon {
  background: #fff !important;
}

.selectedCompetency .truncate span {
  display: block !important;
}

.selectedCompetency .truncate h5 {
  color: white;
}
</style>
